import React, { Component } from 'react'
import css from './styles.scss'

export class StringEditor extends Component {
  constructor ({ variable, variableName, updateParent }) {
    super()
    this.state = {
      str: variable.args[0] || ''
    }
  }

  handleUpdateString = evt => {
    this.setState({
      str: evt.target.value
    })
  }

  componentWillReceiveProps (nextProps) {
    const { report, save, variableName } = this.props
    if (nextProps.report === true && report === false) {
      save(variableName, [this.state.str])
    }
  }

  render () {
    const { str } = this.state
    return (
      <div>
        <input
          className={css.option}
          type='text'
          value={str}
          onChange={this.handleUpdateString}
        />
      </div>
    )
  }
}
export default StringEditor



// WEBPACK FOOTER //
// /app/js/components/EditVariable/StringEditor/index.js